// extracted by mini-css-extract-plugin
export default {"app-select":"cd58dc","app-select__label":"c9fceb","app-select__input":"a99c14","app-select--disabled":"bb7be4","app-select--empty":"b8f145","app-select--focused":"f8a2fb"};